import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const rejectQuoteApi = createApi({
  reducerPath: "rejectQuoteApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getRejectedQuote: builder.query({
      query: () => `/api/staff/rejectedQuote`,
    }),
    rejectRevoke: builder.mutation({
      query: ({ getQuoteId }) => ({
        url: `/api/staff/reject-revoke/${getQuoteId}`,
        method: "PUT",
      }),
    }),
  }),
});

export const { useGetRejectedQuoteQuery, useRejectRevokeMutation } = rejectQuoteApi;
